import { ToggleButton } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const StyledSchedulerButton = styled(ToggleButton, {
  base: {
    textStyle: 'fineprint',
    minWidth: '95px',
    outlineWidth: 0,
    md: {
      textStyle: 'body-sm',
      minWidth: '118px',
    },
  },
});

export const SchedulerList = styled('ul', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 0,
  },
});

export const SchedulerListItem = styled('li', {
  base: {
    display: 'inline-block',
    margin: '{spacing.200} {spacing.200} {spacing.200} 0',
  },
});
